import { DeploymentPipelinesStatus } from '@wix/ambassador-document-management-editor-deployments-v1-deployment/types';
import { z } from 'zod';

export const deployAppResponseSchema = z.object({
  deploymentInfo: z.object({
    deploymentId: z.string(),
    deploymentUrl: z.string().url(),
    deploymentShortUrl: z.string().nullish(),
    deployedRevision: z.string(),
    isPublishPipelineDeployment: z.boolean(),
  }),
});

export const resolveNpmDependenciesSchema = z.object({
  jobId: z.string().uuid(),
});

export const npmDependenciesLockFileResponseSchema = z.object({
  result: z.object({
    npmDependenciesLockFile: z.string().url(),
  }),
});

export const getDeploymentResponseSchema = z.object({
  deployment: z.object({
    deploymentPipelinesStatus: z.enum([
      DeploymentPipelinesStatus.IN_PROGRESS,
      DeploymentPipelinesStatus.SUCCESS,
      DeploymentPipelinesStatus.ERROR,
    ]),
  }),
});
